/**
 * Floating Label Component
 * Handles floating label behavior for input fields
 * Single Responsibility: Floating label animation
 * 
 * @package betbeast
 */

export class FloatingLabel {
    constructor(form) {
        this.form = form;
        this.init();
    }

    init() {
        const inputs = this.form.querySelectorAll('input[placeholder]:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]), select[placeholder]');
        
        inputs.forEach(input => {
            const field = input.closest('.field');
            if (!field) return;

            const placeholder = input.getAttribute('placeholder');
            if (!placeholder) return;

            // Create floating label element if it doesn't exist
            let floatingLabel = field.querySelector('.field__floating-label');
            if (!floatingLabel) {
                floatingLabel = document.createElement('div');
                floatingLabel.className = 'field__floating-label';
                floatingLabel.textContent = placeholder;
                field.insertBefore(floatingLabel, field.firstChild);
            }

            // Update label visibility
            const updateLabel = () => {
                const isSelect = input.tagName === 'SELECT';
                const hasValue = isSelect ? (input.value && input.value !== '') : input.value;
                
                if (hasValue || document.activeElement === input) {
                    floatingLabel.classList.add('is-visible');
                } else {
                    floatingLabel.classList.remove('is-visible');
                }
            };

            // Initial state
            updateLabel();

            // Event listeners
            input.addEventListener('focus', updateLabel);
            input.addEventListener('blur', updateLabel);
            input.addEventListener('input', updateLabel);
            input.addEventListener('change', updateLabel);
        });
    }
}